import { render, staticRenderFns } from "./DfTelephoneField.vue?vue&type=template&id=38ee7caa&scoped=true&"
import script from "./DfTelephoneField.vue?vue&type=script&lang=js&"
export * from "./DfTelephoneField.vue?vue&type=script&lang=js&"
import style0 from "./DfTelephoneField.vue?vue&type=style&index=0&id=38ee7caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ee7caa",
  null
  
)

export default component.exports